var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuse-content-wrapper"},[_c('vuse-section-definition',{attrs:{"title":_vm.page,"breadcrumbs":_vm.breadcrumbs,"icon":""}}),_c('v-container',{attrs:{"fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }